import {
    ChangeDetectorRef,
    Directive,
    ElementRef,
    Host, HostListener,
    OnInit,
    Optional,
    SimpleChange
} from "@angular/core";
import { NgControl } from "@angular/forms";
import { MaskDirective } from "ngx-mask";
  
  @Directive({
    selector: "[tele-phone-mask]",
  })
  export class TelePhoneMaskDirective implements OnInit {
    mask10 = "000 0000 000";
    mask11 = "000 0000 0000";
    currentMask = this.mask10;
    currentValue = null;
  
    constructor(
      private control: NgControl,
      private cdr: ChangeDetectorRef,
      @Host() @Optional() private mask: MaskDirective,
      private el: ElementRef
    ) {}
  
    ngOnInit(): void {
      this.mask.maskExpression = this.currentMask;
      this.mask.ngOnChanges({
        maskExpression: new SimpleChange("", this.currentMask, true),
      });
  
      this.cdr.detectChanges();
    }
  
    @HostListener("ngModelChange", ["$event"])
    onModelChange(event) {
      let newValue = this.el.nativeElement.value.replace(/ /g, "");
      if (newValue != null && this.currentValue !== newValue) {
        this.currentValue = newValue;
        this.control.control.setValue(this.currentValue);
        this.processInputChange(newValue);
      }
    }
  
    @HostListener("keydown.backspace", ["$event"])
    handleKeyboardEvent(event: KeyboardEvent) {
      let newValue = this.el.nativeElement.value.replace(/ /g, "");
      if (newValue != null && this.currentValue !== newValue) {
        this.currentValue = newValue;
        this.control.control.setValue(this.currentValue);
        this.processInputChange(newValue);
      }
    }
  
    private processInputChange(telephone: string) {
      if (telephone.length <= 10) {
        if (this.currentMask != this.mask10) {
          this.currentMask = this.mask10;
          setTimeout(() => {
            this.mask.ngOnChanges({
              maskExpression: new SimpleChange(null, this.mask10, false),
            });
          }, 100);
        }
      } else {
        this.currentMask = this.mask11;
        setTimeout(() => {
          this.mask.ngOnChanges({
            maskExpression: new SimpleChange(null, this.mask11, false),
          });
        }, 100);
      }
  
      this.cdr.detectChanges();
    }
  }
  